import { z } from 'zod';

/**
 * The contact a code proves. Backed by the Postgres enum
 * `access.verification_channel` (P30a) — append only, never reorder.
 *
 * Deliberately **not** `NotificationChannel`: `sms` is a way to reach a
 * member's phone with a challenge, never a notice preference (P21e1).
 */
export const VERIFICATION_CHANNELS = ['email', 'sms'] as const;

export const VerificationChannelSchema = z.enum(VERIFICATION_CHANNELS);

export type VerificationChannel = z.infer<typeof VerificationChannelSchema>;
